import React  from 'react'
import { IndexLink, Link } from 'react-router'
import RegionSelect from './region-select'
import Match from 'lib/components/match'
import RA from 'ra-config'

class Toolbar extends React.PureComponent {
  render() {
    const { region, section } = this.props
    const { dataDate } = RA.app

    return (
      <Match min="medium-min">
        <div className="toolbar split-nav">
          <div className="split-nav__main">
            <span className="toolbar__current">
              <RegionSelect region={region} />
            </span>

            <ul className="tabs">
              <li>
                <IndexLink
                  className="toolbar__tab"
                  to={`/${section}`}
                  activeClassName="active"
                >
                  <span>Dashboard</span>
                </IndexLink>
              </li>
              <li>
                <Link
                  className="toolbar__tab"
                  to={`/${section}/compare`}
                  activeClassName="active"
                >
                  <span>Compare</span>
                </Link>
              </li>
            </ul>
          </div>

          <div className="toolbar__asof">Data as of {dataDate}</div>

          <div className="split-nav__aux" />
        </div>
      </Match>
    )
  }
}

export default Toolbar



// WEBPACK FOOTER //
// ./src/components/toolbar.js